<template>
  <div
    class="encrypting"
  >
    <div class="encrypting-animation">
      <LottiePlayer
        :height="300"
        :width="300"
        :animation-data="animationData"
      />
    </div>

    <div class="encrypting-text">
      <p> Securing Connection </p>
      <p> With Your Bank...</p>
    </div>
  </div>
</template>

<script>
import LottiePlayer from '@/components/common/lottie/LottiePlayer.vue'

export default {
  name: 'Encrypting',

  // Components
  components: {
    LottiePlayer
  },

  data () {
    return {
      animationData: require('@/assets/lottie/flinks/encrypting.json')
    }
  }
}
</script>

<style scoped lang="scss">
.encrypting {
  @apply text-center border-2 border-solid border-gray-300 rounded-20 bg-white h-650;

  &-animation {
    @apply mt-150;
  }

  &-text {
    @apply font-semibold;
  }
}
</style>
